import icon_instruccion_1 from "../assets/Page_Test1&Instructions/Page_Test1_Instructions/Icon_Tests1-1.svg";
import icon_instruccion_2 from "../assets/Page_Test1&Instructions/Page_Test1_Instructions/Icon_Tests1-2.svg";
import icon_instruccion_3 from "../assets/Page_Test1&Instructions/Page_Test1_Instructions/Icon_Tests1-3.svg";
import test_icon_instruction1 from "../assets/Page_Test2_Instructions/Icon_Tests2-1.svg";
import letraE from "../assets/Page_Test1&Instructions/Page_Test1_Test/Snellen.svg";
import respuestaE from "../assets/Page_Test1&Instructions/Page_Test1_Test/Snellen_Button.svg";
import imgRegilla from "../assets/Page_Test3&Instructions/Page_Test3_Test/Test_Main-Component.png";
import test4_instruccion_1 from "../assets/Page_Test4&Instructions/Page_Test4_Instructions/Icon_Tests4-1.svg";
import test4_instruccion_2 from "../assets/Page_Test4&Instructions/Page_Test4_Instructions/Icon_Tests4-2.svg";
import test4_instruccion_3 from "../assets/Page_Test4&Instructions/Page_Test4_Instructions/Icon_Tests4-3.svg";
import imgTest4_1 from "../assets/Page_Test4&Instructions/Page_Test4_Test/Test_Ishihara-1-(12).png";
import imgTest4_2 from "../assets/Page_Test4&Instructions/Page_Test4_Test/Test_Ishihara-2-(2).png";
import imgTest4_3 from "../assets/Page_Test4&Instructions/Page_Test4_Test/Test_Ishihara-3-(74).png";
import imgTest4_4 from "../assets/Page_Test4&Instructions/Page_Test4_Test/Test_Ishihara-4-(6).png";
import imgTest4_5 from "../assets/Page_Test4&Instructions/Page_Test4_Test/Test_Ishihara-5-(42).png";
import imgTest_5 from "../assets/Page_Test5&Instructions/Page_Test5_Test/Test_5.png";
import text6_instruccion from "../assets/Page_Test6&Instructions/Page_Test6_Instructions/Icon_Tests6-1.svg";
import test6_imgComparacionClara1 from "../assets/Page_Test6&Instructions/TesPage_Test6_Test/Test.png"
import test6_imgComparacionBorrosa2 from "../assets/Page_Test6&Instructions/TesPage_Test6_Test/Test_Blur.png"
import test6_imgComparacionClara3 from "../assets/Page_Test6&Instructions/TesPage_Test6_Test/1.png"
import test6_imgComparacionBorrosa4 from "../assets/Page_Test6&Instructions/TesPage_Test6_Test/2.png"

export const testsData = {
  1: {
    id: 1,
    titulo: "Test de Agudeza Visual",
    seleccionOjo: true,
    instrucciones: [
      {
        paso: 1,
        texto:
          "Colócate a 40 cm de la pantalla de tu dispositivo o computadora",
        img: icon_instruccion_1,
      },
      {
        paso: 2,
        texto:
          "Si usas lentes, decide si quieres hacer la prueba con o sin ellos",
        img: icon_instruccion_2,
      },
      {
        paso: 3,
        texto: "Cubre el ojo que se indique",
        img: icon_instruccion_3,
      },
    ],
    preguntas: [
      {
        id: 1,
        tipo: "imagen-rotacion",
        texto: "Selecciona la posición correcta",
        imagenPregunta: {
          src: letraE,
          tamaño: 20, // ✅ Más grande
          rotacion: 0, // ✅ Rotada 270 grados
        },
        opciones: [
          { imagen: respuestaE, rotacion: 90 },
          { imagen: respuestaE, rotacion: 180 },
          { imagen: respuestaE, rotacion: 0 },
          { imagen: respuestaE, rotacion: 270 },
        ],
        respuestaCorrecta: 2,
      },
      {
        id: 2,
        tipo: "imagen-rotacion",
        texto: "Selecciona la posición correcta",
        imagenPregunta: {
          src: letraE,
          tamaño: 16, // ✅ Más grande
          rotacion: 90, // ✅ Rotada 270 grados
        },
        opciones: [
          { imagen: respuestaE, rotacion: 90 },
          { imagen: respuestaE, rotacion: 180 },
          { imagen: respuestaE, rotacion: 0 },
          { imagen: respuestaE, rotacion: 270 },
        ],
        respuestaCorrecta: 0,
      },
      {
        id: 3,
        tipo: "imagen-rotacion",
        texto: "Selecciona la posición correcta",
        imagenPregunta: {
          src: letraE,
          tamaño: 12, // ✅ Más grande
          rotacion: 180, // ✅ Rotada 270 grados
        },
        opciones: [
          { imagen: respuestaE, rotacion: 90 },
          { imagen: respuestaE, rotacion: 180 },
          { imagen: respuestaE, rotacion: 0 },
          { imagen: respuestaE, rotacion: 270 },
        ],
        respuestaCorrecta: 1,
      },
      {
        id: 4,
        tipo: "imagen-rotacion",
        texto: "Selecciona la posición correcta",
        imagenPregunta: {
          src: letraE,
          tamaño: 8, // ✅ Más grande
          rotacion: 270, // ✅ Rotada 270 grados
        },
        opciones: [
          { imagen: respuestaE, rotacion: 90 },
          { imagen: respuestaE, rotacion: 180 },
          { imagen: respuestaE, rotacion: 0 },
          { imagen: respuestaE, rotacion: 270 },
        ],
        respuestaCorrecta: 3,
      },
      {
        id: 5,
        tipo: "imagen-rotacion",
        texto: "Selecciona la posición correcta",
        imagenPregunta: {
          src: letraE,
          tamaño: 4, // ✅ Más grande
          rotacion: 180, // ✅ Rotada 270 grados
        },
        opciones: [
          { imagen: respuestaE, rotacion: 90 },
          { imagen: respuestaE, rotacion: 180 },
          { imagen: respuestaE, rotacion: 0 },
          { imagen: respuestaE, rotacion: 270 },
        ],
        respuestaCorrecta: 1,
      },
    ],
  },
  2: {
    id: 2,
    titulo: "Visión cercana",
    seleccionOjo: true,
    instrucciones: [
      {
        paso: 1,
        texto:
          "Colócate a 35-40 cm de la pantalla de tu dispositivo o computadora",
        img: test_icon_instruction1,
      },
      {
        paso: 2,
        texto: "Cubre el ojo que se indique",
        img: icon_instruccion_3,
      },
    ],
    preguntas: [
      {
        id: 1,
        tipo: "textoPregunta",
        texto: "Selecciona la posición correcta",
        textoPregunta: {
          text: "La visión es uno de los sentidos más importantes. Nos permite percibir la forma, distancia, posición, tamaño y color de todos los objetos y seres que nos rodean.",
          tamañoText: 16,
          lineHeight: 1.5,
        },
        pregunta: "¿Cómo percibes el texto anterior?",
        opciones: [{ text: "Claro" }, { text: "Borroso" }],
        respuestaCorrecta: 0,
      },
      {
        id: 2,
        tipo: "textoPregunta",
        texto: "Selecciona la posición correcta",
        textoPregunta: {
          text: "La luz entra en el ojo a través de la córnea, pasa por la pupila y el cristalino, y se enfoca en la retina. Es un proceso complejo que ocurre en fracciones de segundo para que podamos interpretar el mundo.",
          tamañoText: 12,
          width: 73,
          lineHeight: 1.5,
        },
        opciones: [{ text: "Claro" }, { text: "Borroso" }],
        respuestaCorrecta: 0,
      },
      {
        id: 3,
        tipo: "textoPregunta",
        texto: "Selecciona la posición correcta",
        textoPregunta: {
          text: "El ojo humano es un órgano fotorreceptor, cuya función consiste en recibir los rayos luminosos procedentes de los objetos presentes en el mundo exterior y transformarlos en impulsos eléctricos que son conducidos al centro nervioso de la visión en la parte posterior del cerebro.",
          tamañoText: 8,
          width: 70,
          lineHeight: 1,
        },
        pregunta: "¿Cómo percibes el texto anterior?",
        opciones: [{ text: "Claro" }, { text: "Borroso" }],
        respuestaCorrecta: 0,
      },
      {
        id: 4,
        tipo: "textoPregunta",
        texto: "Selecciona la posición correcta",
        textoPregunta: {
          text: "Para proteger tu visión, se recomienda descansar la vista periódicamente mirando objetos lejanos y asegurarte de tener una iluminación adecuada al leer. Recuerda parpadear con frecuencia para hidratar el ojo y visitar a tu especialista una vez al año para prevenir cualquier cambio en tu graduación.",
          tamañoText: 5,
          width: 46,
          lineHeight: 1,
        },
        pregunta: "¿Cómo percibes el texto anterior?",
        opciones: [{ text: "Claro" }, { text: "Borroso" }],
        respuestaCorrecta: 0,
      },
    ],
  },
  3: {
    id: 3,
    titulo: "Rejilla de Amsler",
    seleccionOjo: true,
    primeraImagen: true,
    instrucciones: [
      {
        paso: 1,
        texto:
          "Colócate a 40 cm de la pantalla de tu dispositivo o computadora",
        img: icon_instruccion_1,
      },
      {
        paso: 2,
        texto:
          "Si usas lentes, decide si quieres hacer la prueba con o sin ellos",
        img: icon_instruccion_2,
      },
      {
        paso: 3,
        texto: "Cubre el ojo que se indique",
        img: icon_instruccion_3,
      },
    ],
    tituloPreguntaGral: "Mira fijamente el punto central durante 10-15 segundos",
    imgGral: imgRegilla,
    ultimaInstruccion:
      "Contesta las siguientes preguntas de acuerdo al ejercicio anterior",
    preguntas: [
      {
        id: 1,
        tipo: "textoCkeckbox",
        textoPregunta: {
          text: "¿Ves todas las líneas rectas?",
        },
        opciones: [{ checkbox: "si" }, { checkbox: "no" }],
        respuestaCorrecta: 0,
      },
      {
        id: 2,
        tipo: "textoCkeckbox",
        textoPregunta: {
          text: "¿Falta alguna parte de la rejilla?",
        },
        opciones: [{ checkbox: "si" }, { checkbox: "no" }],
        respuestaCorrecta: 1,
      },
      {
        id: 3,
        tipo: "textoCkeckbox",
        textoPregunta: {
          text: "¿Ves alguna mancha oscura o borrosa?",
        },
        opciones: [{ checkbox: "si" }, { checkbox: "no" }],
        respuestaCorrecta: 1,
      },
    ],
  },
  4: {
    id: 4,
    titulo: "Agudeza visual a distancia",
    seleccionOjo: false,
    primeraImagen: false,
    todoUnaPag: false,
    instrucciones: [
      {
        paso: 1,
        leyenda: "Las condiciones de luz y la calibración de colores influyen",
        texto: "No uses modo nocturno",
        img: test4_instruccion_1,
      },
      {
        paso: 2,
        leyenda: "Las condiciones de luz y la calibración de colores influyen",
        texto: "Haz el test en un ambiente bien iluminado",
        img: test4_instruccion_2,
      },
      {
        paso: 3,
        leyenda: "Las condiciones de luz y la calibración de colores influyen",
        texto: "Evita el uso de lentes con filtro de color",
        img: test4_instruccion_3,
      },
    ],
    preguntas: [
      {
        id: 1,
        tipo: "imagen-rotacion",
        texto: "¿Qué número logras ver?",
        imagenPregunta: {
          src: imgTest4_1,
        },
        opciones: [
          { imagen: "8", rotacion: 0 },
          { imagen: "12", rotacion: 0 },
          { imagen: respuestaE, rotacion: 0 },
          { imagen: "46", rotacion: 0 },
        ],
        respuestaCorrecta: 1,
      },
      {
        id: 2,
        tipo: "imagen-rotacion",
        texto: "Selecciona la posición correcta",
        imagenPregunta: {
          src: imgTest4_2,
        },
        opciones: [
          { imagen: "7", rotacion: 0 },
          { imagen: "2", rotacion: 0 },
          { imagen: respuestaE, rotacion: 0 },
          { imagen: "17", rotacion: 0 },
        ],
        respuestaCorrecta: 1,
      },
      {
        id: 3,
        tipo: "imagen-rotacion",
        texto: "Selecciona la posición correcta",
        imagenPregunta: {
          src: imgTest4_3,
        },
        opciones: [
          { imagen: "91", rotacion: 0 },
          { imagen: "19", rotacion: 0 },
          { imagen: respuestaE, rotacion: 0 },
          { imagen: "74", rotacion: 0 },
        ],
        respuestaCorrecta: 3,
      },
      {
        id: 4,
        tipo: "imagen-rotacion",
        texto: "Selecciona la posición correcta",
        imagenPregunta: {
          src: imgTest4_4,
        },
        opciones: [
          { imagen: "9", rotacion: 0 },
          { imagen: "6", rotacion: 0 },
          { imagen: respuestaE, rotacion: 0 },
          { imagen: "3", rotacion: 0 },
        ],
        respuestaCorrecta: 1,
      },
      {
        id: 5,
        tipo: "imagen-rotacion",
        texto: "Selecciona la posición correcta",
        imagenPregunta: {
          src: imgTest4_5,
        },
        opciones: [
          { imagen: "12", rotacion: 0 },
          { imagen: "27", rotacion: 0 },
          { imagen: respuestaE, rotacion: 0 },
          { imagen: "42", rotacion: 0 },
        ],
        respuestaCorrecta: 3,
      },
    ],
  },
  5: {
    id: 5,
    titulo: "Rueda de astigmatismo",
    seleccionOjo: true,
    primeraImagen: false,
    todoUnaPag: true,
    instrucciones: [
      {
        paso: 1,
        texto:
          "Colócate a 40 cm de la pantalla de tu dispositivo o computadora",
        img: icon_instruccion_1,
      },
      {
        paso: 2,
        texto:
          "Si usas lentes, decide si quieres hacer la prueba con o sin ellos",
        img: icon_instruccion_2,
      },
      {
        paso: 3,
        texto: "Cubre el ojo que se indique",
        img: icon_instruccion_3,
      },
    ],
    tituloPag: "Mira al centro de la figura",
    tituloPreguntaGral: "Mira al centro de la figura",
    imgGral: imgTest_5,
    ultimaInstruccion:
      "Contesta las siguientes preguntas de acuerdo al ejercicio anterior",
    preguntas: [
      {
        id: 1,
        tipo: "textoCkeckbox",
        textoPregunta: {
          text: "¿Ves líneas  más oscuras o más nítidas que otras?",
        },
        opciones: [{ checkbox: "si" }, { checkbox: "no" }],
        respuestaCorrecta: 1,
      },
      {
        id: 2,
        tipo: "textoCkeckbox",
        textoPregunta: {
          text: "¿Hay líneas que se vean más claras que otras?",
        },
        opciones: [{ checkbox: "si" }, { checkbox: "no" }],
        respuestaCorrecta: 1,
      },
    ],
  },
  6: {
    id: 6,
    titulo: "Simulación Miopía vs Hipermetropía",
    seleccionOjo: false,
    instrucciones: [
      {
        paso: 1,
        texto:
          "Este test orienta sobre si tu problema principal es de lejos o de cerca.",
        leyenda: "La prueba NO mide graduación",
        img: text6_instruccion,
      },
    ],
    preguntas: [
      {
        id: 1,
        tipo: "imgsPregunta",
        imagenPregunta: [{ src: test6_imgComparacionClara1}, { src: test6_imgComparacionBorrosa2 }],
        pregunta: "¿La forma en que ves los letreros lejanos se parece más a la Imagen A o a la Imagen B?",
        opciones: [{ text: "A" }, { text: "B" }],
        respuestaCorrecta: 0,
      },

      {
        id: 1,
        tipo: "imgsPregunta",
        imagenPregunta: [{ src: test6_imgComparacionClara3 }, { src: test6_imgComparacionBorrosa4 }],
        pregunta: "¿La forma en que ves los letreros lejanos se parece más a la Imagen A o a la Imagen B?",
        opciones: [{ text: "A" }, { text: "B" }],
        respuestaCorrecta: 0,
      },
    ],
  },
};
